


























































import { Component, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Components
import ClientProfileBasicConfigurationComp from "@/components/app/global/client/clientProfileBasicConfigurationComp.vue";
import ClientCustomFieldsComp from "@/components/app/global/client/clientCustomFieldsComp.vue";

// Mixins
import ClientInjectorMixin from "@/mixins/clientInjectorMixin";
import Context from "@/mixins/context";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-profile-basic-configuration-comp": ClientProfileBasicConfigurationComp,
    "client-custom-fields-comp": ClientCustomFieldsComp,
    "client-emails-component": () =>
      import("@/components/app/global/client/clientEmailsComp.vue"),
    "billable-entities-component": () =>
      import("@/components/app/global/client/billableEntitiesComp.vue"),
    "client-phones-component": () =>
      import("@/components/app/global/client/clientPhonesComp.vue")
  }
})
export default class AdminClientProfileSettingsView extends Mixins(
  ClientInjectorMixin,
  Context
) {
  // Refs

  public declare $refs: {
    profileBasicForm: ClientProfileBasicConfigurationComp;
    customFieldsForm: ClientCustomFieldsComp;
  };

  // Data

  public isEnabled = {
    profileBasicForm: false,
    customFieldsForm: false
  };
  public isProcessing = {
    profileBasicForm: false,
    customFieldsForm: false
  };
  public refresh = this.initiateRefresh();

  // Methods

  public async validateBeforeSubmit() {
    this.$refs.profileBasicForm.validateBeforeSubmit();
    this.$refs.customFieldsForm.validateBeforeSubmit();
  }

  public revertToInitialState() {
    this.$refs.profileBasicForm.revertToInitialState();
    this.$refs.customFieldsForm.revertToInitialState();
  }

  public initiateRefresh() {
    return {
      profileBasicForm: false,
      customFieldsForm: false
    };
  }

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }

  // Computed

  public get clientId(): IClient["id"] {
    return this.$route.params.clientId;
  }

  public get showFormControls() {
    return _.values(this.isEnabled).includes(true);
  }

  public get showIsProcessingState() {
    return _.values(this.isProcessing).includes(true);
  }

  // Watchers

  @Watch("refresh", { deep: true })
  public onRefreshChange() {
    if (_.values(this.refresh).includes(false)) return;

    this.$clientMethods.reloadData();

    this.$store.dispatch("toast/show", {
      message: this.$t("_sentence.billing_settings_updated")
    });

    this.refresh = this.initiateRefresh();
  }
}
